export class Loader {
    show(element) {
        $(element).next().next().removeClass('hide');
    }

    hide(element) {
        $(element).next().next().addClass('hide');
    }
}